export const getImageUrl = (imageUrl) => {
    const dpr = Math.min(window.devicePixelRatio || 1, 2);
    const height = 700 * dpr;
    return `https:${imageUrl}?h=${height}&q=85`;
};